import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { isNil, useInterval } from "@grandvisionhq/utils";
import { GET_PAYMENT_STATUS_BY_TOKEN } from "../../operations/queries/operations/queries/get-payment-status-by-token.js";
import { mapPaymentState } from "../../mappers/mappers/payment-state.js";
import { errorsMapping } from "../../mappers/mappers/errors-mapping.js";
const useGetPaymentStatusByToken = ({ onError, onCompleted, token, pollInterval = 5e3 } = { token: "" }) => {
  const [getPaymentStatus, { data, error: apolloError, refetch, called }] = useLazyQuery(GET_PAYMENT_STATUS_BY_TOKEN, {
    onError(error2) {
      console.error(error2);
      onError && onError({ reason: "QUERY", error: error2 });
    },
    onCompleted() {
      onCompleted && onCompleted("getOrderByToken");
    },
    fetchPolicy: "network-only",
    variables: {
      token
    }
  });
  const [paymentState, setPaymentState] = React.useState(void 0);
  const [error, setError] = React.useState();
  React.useEffect(() => {
    if (!apolloError) return;
    setError(errorsMapping.SOMETHING_WENT_WRONG);
  }, [apolloError]);
  React.useEffect(() => {
    if (paymentState === "Paid" || paymentState === "Failed" || !isNil(error)) return;
    const currentPaymentState = mapPaymentState(data?.getOrderByToken);
    setPaymentState(currentPaymentState);
  }, [data, error, paymentState]);
  const handler = React.useCallback(async () => {
    if (called && refetch) {
      await refetch();
    } else {
      getPaymentStatus();
    }
  }, [getPaymentStatus, called, refetch]);
  const options = React.useMemo(
    () => ({
      when: paymentState !== "Paid" && paymentState !== "Failed" && isNil(error),
      startImmediate: true
    }),
    [paymentState, error]
  );
  useInterval(handler, pollInterval, options);
  return React.useMemo(
    () => ({
      paymentState,
      error
    }),
    [error, paymentState]
  );
};
export {
  useGetPaymentStatusByToken
};
//# sourceMappingURL=use-get-payment-status-by-token.js.map
